/* FLOW shared effects — reveal-on-scroll (blur-in) + count-up (bg-BG) + sparkles.
   Scroll/rAF based (reliable across browsers + previews; no IntersectionObserver
   dependency, so content is never stuck invisible). Guarded to run once. */
(function () {
  if (window.__flowFx) return;
  window.__flowFx = 1;

  function init() {
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

    function tick(el) {
      if (el.dataset.done) return;
      el.dataset.done = '1';
      var t = parseFloat(el.dataset.count) || 0, d = 1500, s = null;
      if (reduce) { el.textContent = t.toLocaleString('bg-BG'); return; }
      function f(ts) {
        if (!s) s = ts;
        var p = Math.min((ts - s) / d, 1), e = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(t * e).toLocaleString('bg-BG');
        if (p < 1) requestAnimationFrame(f);
      }
      requestAnimationFrame(f);
    }

    var reveals = [].slice.call(document.querySelectorAll('.cv .reveal'));
    var counts = [].slice.call(document.querySelectorAll('.cv .ct'));

    function check() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      reveals = reveals.filter(function (el) {
        var top = el.getBoundingClientRect().top;
        if (top < vh * 0.92) { el.classList.add('in'); return false; }
        return true;
      });
      counts = counts.filter(function (el) {
        var top = el.getBoundingClientRect().top;
        if (top < vh * 0.85) { tick(el); return false; }
        return true;
      });
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { check(); ticking = false; });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    check();
    // safety net: if anything is still hidden after 1.6s (e.g. no scroll yet
    // on a short viewport, or a flaky environment), reveal it so content is
    // never stuck invisible.
    setTimeout(function () {
      reveals.forEach(function (el) { el.classList.add('in'); });
      counts.forEach(function (el) { tick(el); });
      reveals = []; counts = [];
    }, 1600);
    // hard guard: a stat must never sit at 0 if rAF was throttled (background tab /
    // preview / slow device). By now any real count-up (1.5s, started by 1.6s) is done.
    setTimeout(function () {
      [].slice.call(document.querySelectorAll('.cv .ct')).forEach(function (el) {
        var t = parseFloat(el.dataset.count) || 0;
        if (t !== 0 && (el.textContent === '0' || el.textContent === '')) {
          el.textContent = t.toLocaleString('bg-BG');
        }
      });
    }, 3600);

    // sparkles on any [data-spark]
    if (!reduce) {
      var CL = ['#FC809F', '#FF9CB5', '#FFC9D7'];
      document.querySelectorAll('.cv [data-spark]').forEach(function (host) {
        setInterval(function () {
          if (document.hidden) return;
          var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          svg.setAttribute('class', 'spk'); svg.setAttribute('width', '15'); svg.setAttribute('height', '15'); svg.setAttribute('viewBox', '0 0 21 21');
          svg.style.left = (6 + Math.random() * 88) + '%'; svg.style.top = (Math.random() * 100) + '%';
          var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          p.setAttribute('d', 'M9.8 0.8C10.1 0.2 10.9 0.2 11.2 0.8l0.7 1.9c0.5 1.5 0.5 3.7 1.6 4.8 1.1 1.1 3.3 1.1 4.8 1.6l1.9 0.7c0.6 0.2 0.6 1.1 0 1.3l-1.9 0.7c-1.5 0.5-3.7 0.5-4.8 1.6-1.1 1.1-1.1 3.3-1.6 4.8l-0.7 1.9c-0.2 0.6-1.1 0.6-1.3 0l-0.7-1.9c-0.5-1.5-0.5-3.7-1.6-4.8-1.1-1.1-3.3-1.1-4.8-1.6L0.8 11.2c-0.6-0.2-0.6-1.1 0-1.3l1.9-0.7c1.5-0.5 3.7-0.5 4.8-1.6 1.1-1.1 1.1-3.3 1.6-4.8L9.8 0.8Z');
          p.setAttribute('fill', CL[Math.floor(Math.random() * 3)]); svg.appendChild(p);
          svg.animate([{ opacity: 0, transform: 'translate(-50%,-50%) scale(0) rotate(0)' }, { opacity: 1, transform: 'translate(-50%,-50%) scale(1) rotate(90deg)' }, { opacity: 0, transform: 'translate(-50%,-50%) scale(0) rotate(160deg)' }], { duration: 850, easing: 'ease-in-out' });
          host.appendChild(svg); setTimeout(function () { svg.remove(); }, 850);
        }, 440);
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
